import React from 'react';
import { Grid } from '@mui/material';
import ClassInfo from '../../components/main/ClassInfo';

type Props = {}

const SchedulePage = (props: Props) => {
    return (
        <>
            <Grid container spacing={2} sx={{ mt: 5, p: 20, '@media (max-width: 1300px)': { mt: 15, p: 0 } }}>
                <ClassInfo />
            </Grid>
        </>
    )
}

export default SchedulePage